import flatpickr from 'flatpickr' // flatpickr
import 'flatpickr/dist/l10n/ja' // flatpickr日本語化

/*
flatpickrによるデートピッカー
※preset/_js.scssのCSSインポートを有効化して使用する

<input type="text" name="date1" class="js-date">
<input type="text" name="date2" class="js-date">
*/

if (document.getElementsByClassName('js-date')[0]) {
  module()
}

function module() {
  // ブラウザバック時に入力値を戻すためにpageshowで動作させる
  window.addEventListener('pageshow', function () {
    const datepicker = flatpickr('.js-date', {
      // 指定クラスにデートピッカーを付ける
      // minDate: new Date().fp_incr(1), // 最短設定日 n日後から
      // maxDate: new Date().fp_incr(30), // 最長設定日 n日後まで
      // mode: 'range', // 範囲で指定させる
      locale: 'ja',
      altFormat: 'Y-m-d',
      dateFormat: 'Y-m-d',
      disableMobile: true, // SP時にブラウザ標準の日付UIに切り替えない
      // altFormat: 'Y/m/d H:i',
      // dateFormat: 'Y/m/d H:i',
      // enableTime: true, // 時間指定可能にする
      // time_24hr: false, // 24h/AMPM形式
      disable: [
        // 選択禁止する日付　trueを返すと禁止
        // function (date) {
        //   // 指定番号の曜日と合致したら禁止　0:日曜～6:土曜
        //   if (date.getDay() === 0) {
        //     return true
        //   }
        // },
      ],
      onChange: function (selectedDates, dateStr, instance) {},
    })

    // デフォルトのflatpickrにはクリアボタンが無いのでカレンダー内に増設する
    const datepickerList = document.querySelectorAll('.flatpickr-calendar')
    for (let index = 0; index < datepickerList.length; index++) {
      const element = datepickerList[index]
      const datepickerBtn = document.createElement('button')
      datepickerBtn.innerHTML = '×クリア' // 文言
      datepickerBtn.setAttribute('type', 'button')
      datepickerBtn.setAttribute('style', 'padding: 5px;color: #F67A79')
      datepickerBtn.setAttribute('data-datepicker-clear', index)
      datepickerBtn.addEventListener('click', function (e) {
        if (Array.isArray(datepicker)) {
          datepicker[this.dataset.datepickerClear].clear() // クリア処理
          datepicker[this.dataset.datepickerClear].close() // カレンダーを閉じる
        } else {
          datepicker.clear() // クリア処理
          datepicker.close() // カレンダーを閉じる
        }
      })
      element.appendChild(datepickerBtn)
    }
  })
}
